import { WidgetSizeEnum } from '@core/types'

export const PLAYER_DECK_THUMBNAIL_WIDTHS = {
  [WidgetSizeEnum.LARGE]: 300, // Large is default
  [WidgetSizeEnum.MEDIUM]: 255,
  [WidgetSizeEnum.SMALL]: 210,
}

export const PRODUCT_CARD_HEIGHT = 72

/**
 * Takes a widget param size and whether the product carousel is in a bottom layout
 * and returns the appropriate thumbnail dimensions.
 */
export function getThumbnailSize(
  size: WidgetSizeEnum | undefined,
): [number, number] {
  const width = PLAYER_DECK_THUMBNAIL_WIDTHS[size ?? WidgetSizeEnum.LARGE]
  const height = Math.round(width * (16 / 9))

  return [width, height]
}
